import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-bonus.svg";
import * as styles from "./Icon.module.scss";

type BonusProps = React.SVGProps<SVGSVGElement>;

export const Bonus = ({ className, ...props }: BonusProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
